<script setup>

import {ref} from "vue";
import DetailEditorLayout from "../../components/view-components/DetailEditorLayout.vue";
import UpkeepFormHost from "../../components/ui-components/UpkeepFormHost.vue";
const formHost = ref();
const save = (callback) => {
  formHost.value.save(callback);
}

</script>

<template>
  <detail-editor-layout :title="$route.meta.type === 'create' ? $t('common.create_record_title') : $t('common.edit_record_title')" @on-save="save" @on-save-back="save()">
    <div class="editor">
      <div class="ed-form">
        <upkeep-form-host ref="formHost"></upkeep-form-host>
      </div>
    </div>
  </detail-editor-layout>
</template>

<style scoped lang="scss">

</style>
